/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

const ESTATE_BASE_LINK = '/admin/estates'

export function getEstateCreateLink (params?: Record<string, unknown>) {
  return `${ESTATE_BASE_LINK}/create?${stringify(params)}`
}

export function getEstateLink (id: number | string) {
  return `${ESTATE_BASE_LINK}/${id}/edit`
}

export function getEstateInterventionListLink (id: number | string) {
  return `${ESTATE_BASE_LINK}/${id}/interventions`
}

export function getEstateLeaseListLink (id: number | string) {
  return `${ESTATE_BASE_LINK}/${id}/leases`
}

export function getEstateMandateListLink (id: number | string) {
  return `${ESTATE_BASE_LINK}/${id}/mandates`
}

export function getEstatePrintLink (id: number | string) {
  return `${ESTATE_BASE_LINK}/${id}/print`
}

export function getEstateProspectingListLink (id: number | string) {
  return `${ESTATE_BASE_LINK}/${id}/prospecting`
}

export function getEstateListLink (params?: Record<string, unknown>) {
  return `${ESTATE_BASE_LINK}?${stringify(params)}`
}
